// src/components/ProgressUpdateModal.ts
import { appStore } from "../state/store";
export class ProgressUpdateModal {
    constructor(app, entityId) {
        this.app = app;
        this.entityId = entityId;
    }
    closeModal() {
        const modalContainer = document.getElementById('modal-container');
        if (modalContainer) {
            modalContainer.innerHTML = '';
        }
    }
    render() {
        const entity = appStore.getState().mainAppState.entities[this.entityId];
        if (!entity) {
            return `<div class="modal"><p class="error">Entity not found.</p></div>`;
        }
        return `
            <div class="modal" style="display: block;">
                <div class="modal-content">
                    <span class="close-button" id="close-progress-modal">&times;</span>
                    <h3>Update Progress for: ${entity.name}</h3>
                    <p>Current: ${entity.currentValue} / ${entity.goalValue} ${entity.goalUnit}</p>
                    <form id="progress-form">
                        <div class="form-group">
                            <label for="progress-value">New Total Progress (${entity.goalUnit}):</label>
                            <input type="number" id="progress-value" step="1" placeholder="${entity.currentValue}" required>
                        </div>
                        <div class="form-group">
                            <label for="progress-notes">Notes (Optional):</label>
                            <textarea id="progress-notes" rows="3"></textarea>
                        </div>
                        <div class="button-container">
                            <button type="submit" class="button-primary">Save Progress</button>
                        </div>
                    </form>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        var _a, _b;
        (_a = document.getElementById('close-progress-modal')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.closeModal();
        });
        (_b = document.getElementById('progress-form')) === null || _b === void 0 ? void 0 : _b.addEventListener('submit', (e) => {
            e.preventDefault();
            const valueInput = document.getElementById('progress-value');
            const notesInput = document.getElementById('progress-notes');
            const newTotalValue = parseFloat(valueInput.value);
            const currentEntity = appStore.getState().mainAppState.entities[this.entityId];
            if (!isNaN(newTotalValue) && currentEntity) {
                // This keeps the `Contribution` pure: it represents the *change*.
                const increment = newTotalValue - currentEntity.currentValue;
                // Call the store action with the calculated increment
                appStore.addContribution(this.entityId, {
                    value: increment,
                    notes: notesInput.value
                });
                // Close the modal and re-render the parent dashboard
                this.closeModal();
                this.app.renderCurrentView();
            }
        });
    }
}
